import axios from 'axios';
import { Dispatch } from 'redux';
import { errorHandler } from 'services/axiosService';

import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { AssignedWorkflow, AssignedWorkflowsQueryParams, AssignWorkflowTemplatePayload, AvailableWorkflowTemplate } from 'data/models/Workflows';
import { responseListMapper, responseEntityMapper } from '@qwealth/qcore';

export const fetchAvailableWorkflowTemplates = async (householdQid: string, dispatch: Dispatch): Promise<AvailableWorkflowTemplate[]> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate/household/${householdQid}`);
    return responseListMapper<AvailableWorkflowTemplate>(response);
  } catch (e) {
    errorHandler(dispatch, `API Error: Failed Fetching Available Workflow Templates for Household ${householdQid}`)(e);
    return [];
  }
};

export const postAssignWorkflowTemplates = async (
  payload: AssignWorkflowTemplatePayload,
  dispatch: Dispatch,
): Promise<AssignedWorkflow[] | undefined> => {
  try {
    const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/workflowTemplate/household`, payload);
    return responseListMapper<AssignedWorkflow>(response);
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Assigning Workflow Templates')(e);
    return undefined;
  }
};

export const fetchAssignedWorkflows = async (queryParams: AssignedWorkflowsQueryParams, dispatch: Dispatch): Promise<AssignedWorkflow[]> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/workflows`, { params: queryParams });
    return responseListMapper<AssignedWorkflow>(response);
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Assigned Workflows')(e);
    return [];
  }
};

export const fetchAssignedWorkflow = async (id: number, dispatch: Dispatch): Promise<AssignedWorkflow | undefined> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/workflows`, { params: { id } });
    return responseEntityMapper<AssignedWorkflow>(response);
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Assigned Workflow')(e);
    return undefined;
  }
};

export const patchAssignedWorkflow = async (payload: AssignedWorkflow, dispatch: Dispatch): Promise<AssignedWorkflow | undefined> => {
  try {
    const response = await axios.patch(`${REACT_APP_QWEALTH_API_V3}/workflows/${payload.id}`, payload);
    return responseEntityMapper<AssignedWorkflow>(response);
  } catch (e) {
    errorHandler(dispatch, `API Error: Failed updating Workflow: ${payload.name}`)(e);
    return undefined;
  }
};

export const deleteAssignedWorkflow = async (assignedWorkflowId: number, dispatch: Dispatch): Promise<number | undefined> => {
  try {
    const response = await axios.delete(`${REACT_APP_QWEALTH_API_V3}/workflows/${assignedWorkflowId}`);
    return responseEntityMapper<any>(response).workflowId;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Deleting Assigned Workflow')(e);
    return undefined;
  }
};
